import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollHistoryReport extends Layout {
    checkboxIncludePayAdjustmentHistory: Checkbox;
    checkboxIncludeSettlementHistory: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    officePayrollHistoryDatasource: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxPayeeType: Textbox;
}
